<script>
	export let state = false;
	export let active = 'Active';
	export let inactive = 'Inactive';
</script>

<div>
	{#if state}
		<span class="status active">{active}</span>
	{:else}
		<span class="status">{inactive}</span>
	{/if}
</div>

<style>
	.status {
		position: relative;
		padding-left: 20px;
		white-space: nowrap;
	}
	.status::before {
		content: '';
		width: 7px;
		height: 7px;
		border: 1px solid #000;
		border-radius: 50%;
		position: absolute;
		left: 0;
		top: 30%;
	}
	.status.active::before {
		border: 1px solid #2dc307;
		background-color: #2dc307;
	}
</style>
